import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";

export default function ProductFaq({ items = [] }) {
  const [open, setOpen] = useState(0);

  return (
    <div className="border-t border-white/10" data-testid="faq-list">
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <div key={i} className="border-b border-white/10">
            <button
              onClick={() => setOpen(isOpen ? -1 : i)}
              data-testid={`faq-question-${i}`}
              className="flex w-full items-center justify-between gap-6 py-6 text-left"
            >
              <span className="font-display text-lg lg:text-xl font-bold tracking-tight text-white">
                {item.q}
              </span>
              <span
                className={`flex h-8 w-8 shrink-0 items-center justify-center border transition-colors duration-300 ${
                  isOpen ? "border-[#e01e37] text-[#e01e37]" : "border-white/15 text-white/60"
                }`}
              >
                <Plus
                  className={`h-4 w-4 transition-transform duration-300 ${isOpen ? "rotate-45" : ""}`}
                />
              </span>
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                  className="overflow-hidden"
                >
                  <p className="max-w-2xl pb-6 text-base leading-relaxed text-white/55">
                    {item.a}
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
